export const setTheme = theme =>({
    type:"SET_THEME",
    payload:theme
});

export const setLanguage = langauge =>({
    type:"SET_LANGUAGE",
    payload:langauge
})